import empty from './empty'
import admin from './admin'
import map from './map'
import customer from './customer'
import cargo from './cargo'
import baseData from './baseData'
import octopus from './octopus'
import system from './system'
import lease from './lease'

const routes = [
  { path: '*', component: resolve => require(['@/components/error404'], resolve), meta: { emptyPage: true } },
  { path: '/', component: resolve => require(['@/views/Login'], resolve), meta: { emptyPage: true } },
  { path: '/error', component: resolve => require(['@/components/error'], resolve), meta: { emptyPage: true } },
  { path: '/error404', component: resolve => require(['@/components/error404'], resolve), meta: { emptyPage: true } },
  ...empty,
  ...admin,
  ...map,
  ...customer,
  ...cargo,
  ...baseData,
  ...octopus,
  ...lease,
  ...system
]

export default routes



// WEBPACK FOOTER //
// ./src/config/router/index.js